export default class Feature {
	/** @type {int} */
	id = 0;
	code = '';
	status = 'public';
	name = '';

	constructor(feature) {
		if (feature) {
			this.id = parseInt(feature.id);
			this.code = feature.code;
			this.status = feature.status;
			this.name = feature.name;
		}
	}
}